var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#617995;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.08,9.99V5.85L2.09,6.21L1.83,5.34l1.7-0.68h0.66v5.33H3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.04,4.96c0.19-0.12,0.4-0.22,0.64-0.29s0.49-0.11,0.78-0.11c0.53,0,0.95,0.14,1.25,0.42s0.46,0.68,0.46,1.18 c0,0.21-0.03,0.41-0.08,0.6C9.03,6.96,8.96,7.14,8.86,7.31c-0.1,0.17-0.21,0.33-0.34,0.49S8.25,8.1,8.09,8.25 C7.93,8.41,7.77,8.56,7.62,8.7s-0.3,0.27-0.44,0.4h2.03v0.89H5.9L5.75,9.35c0.14-0.15,0.28-0.29,0.4-0.41 C6.26,8.82,6.38,8.7,6.48,8.59c0.11-0.11,0.21-0.22,0.31-0.32s0.2-0.22,0.31-0.34c0.12-0.13,0.23-0.27,0.35-0.4 C7.57,7.4,7.67,7.26,7.76,7.12C7.85,6.98,7.92,6.84,7.97,6.7C8.03,6.55,8.06,6.4,8.06,6.25c0-0.25-0.07-0.45-0.22-0.59 C7.7,5.52,7.5,5.45,7.24,5.45c-0.2,0-0.37,0.03-0.53,0.08s-0.3,0.12-0.42,0.2L6.04,4.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.99,8.54c0,0.24-0.05,0.46-0.15,0.64s-0.23,0.35-0.4,0.48c-0.17,0.13-0.37,0.24-0.6,0.31 c-0.23,0.07-0.47,0.11-0.74,0.11c-0.25,0-0.49-0.03-0.74-0.08c-0.25-0.05-0.47-0.12-0.66-0.21l0.18-0.83 c0.17,0.07,0.34,0.13,0.52,0.18c0.18,0.05,0.37,0.07,0.57,0.07c0.3,0,0.53-0.07,0.68-0.2c0.15-0.13,0.22-0.3,0.22-0.5 c0-0.27-0.11-0.47-0.34-0.59c-0.22-0.12-0.51-0.18-0.86-0.18h-0.45V6.85h0.3c0.4,0,0.7-0.07,0.92-0.22 c0.22-0.14,0.32-0.34,0.32-0.59c0-0.19-0.07-0.34-0.2-0.44c-0.13-0.1-0.32-0.16-0.56-0.16c-0.34,0-0.66,0.07-0.96,0.22l-0.19-0.79 c0.17-0.1,0.38-0.17,0.62-0.23c0.24-0.06,0.5-0.08,0.76-0.08c0.23,0,0.44,0.03,0.64,0.09s0.37,0.14,0.52,0.26 c0.15,0.11,0.26,0.25,0.34,0.41c0.08,0.16,0.12,0.34,0.12,0.54c0,0.3-0.08,0.57-0.25,0.8c-0.17,0.23-0.42,0.42-0.75,0.56 c0.15,0.04,0.29,0.1,0.43,0.18s0.25,0.17,0.36,0.28c0.1,0.11,0.18,0.24,0.24,0.38C13.96,8.21,13.99,8.37,13.99,8.54z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNum);
export default __webpack_public_path__ + "static/media/num.e53dc2370f664f929c233017d830635b.svg";
export { ForwardRef as ReactComponent };